import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["hoverable", "cardLabel", "form", "onClickCard", "onAssignTest", "onRename", "onDelete", "onDuplicateForm", "onMove", "loadingFormId"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CardSupportText, getColor, getSize, SecondaryButton } from '@lib/common';
import { FormStatus, UnixTimestamp } from '@module/form';
import styled from '@xstyled/styled-components';
import { Card, Divider, Tooltip } from 'antd';
import { FormCardDropdownComponent } from './form-card-dropdown.component';
import { AudioOutlined, BookOutlined, CalendarOutlined, EditOutlined, FileTextOutlined, UnorderedListOutlined, UsergroupAddOutlined, WechatOutlined } from '@ant-design/icons';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { getFormCoverImageUrl } from '../form-cover-image.utils';
import { getExploreCoverGradient } from '../explore-card/explore-card.gradients';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SKILL_TAG_KEYS = new Set(['Reading', 'Writing', 'Listening', 'Speaking']);
var SKILL_ICONS = {
  Reading: /*#__PURE__*/_jsx(BookOutlined, {}),
  Writing: /*#__PURE__*/_jsx(EditOutlined, {}),
  Listening: /*#__PURE__*/_jsx(AudioOutlined, {}),
  Speaking: /*#__PURE__*/_jsx(WechatOutlined, {})
};
var MAX_VISIBLE_TAGS = 3;
var TITLE_LINE_HEIGHT = 1.4;
var TITLE_MAX_LINES = 2;
var StyledCard = styled(Card)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: 14px;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  background: #ffffff;\n  box-shadow: 0 2px 8px rgba(28, 30, 32, 0.06);\n  display: flex;\n  flex-direction: column;\n  transition:\n    transform 0.22s ease,\n    box-shadow 0.22s ease,\n    border-color 0.22s ease;\n\n  .ant-card-body {\n    flex: 1 1 auto;\n    padding: 16px 18px 18px !important;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  &.ant-card-hoverable:hover {\n    transform: translateY(-3px);\n    border-color: ", ";\n    box-shadow: 0 10px 24px rgba(28, 30, 32, 0.1);\n  }\n"])), getColor('fillIntSubActive'), getColor('fillIntSubHover'));
var StyledCoverWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 152px;\n  overflow: hidden;\n  background: ", ";\n"])), function (props) {
  return props.$hasImage ? '#f3f4f6' : props.$gradient;
});
var StyledCoverImage = styled.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n  filter: brightness(0.95);\n  transition: filter 0.22s ease;\n\n  ", ":hover & {\n    filter: brightness(1);\n  }\n"])), StyledCard);
var TagsWrap = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  right: 48px;\n  z-index: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 6px;\n"])));
var CoverPill = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  max-width: 100%;\n  padding: 5px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-shadow: 0 1px 3px rgba(28, 30, 32, 0.1);\n\n  .anticon {\n    font-size: 11px;\n    flex-shrink: 0;\n  }\n"])));
var CategoryPill = styled(CoverPill)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.9);\n"])), getColor('fillIntActive'));
var SkillPill = styled(CoverPill)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: #c2410c;\n  background: rgba(255, 251, 235, 0.96);\n  border: 1px solid rgba(251, 191, 36, 0.35);\n"])));
var TopicPill = styled(CoverPill)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: #9a3412;\n  background: rgba(255, 237, 213, 0.96);\n  border: 1px solid rgba(251, 146, 60, 0.35);\n"])));
var DefaultPill = styled(CoverPill)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: rgba(255, 255, 255, 0.94);\n  border: 1px solid rgba(255, 255, 255, 0.8);\n"])), getColor('textIntSub'));
var OverflowPill = styled(CoverPill)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: rgba(255, 255, 255, 0.94);\n  border: 1px solid rgba(255, 255, 255, 0.85);\n  min-width: 32px;\n  justify-content: center;\n  padding-inline: 8px;\n"])), getColor('textIntSub'));
var StyledTopRightAction = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 2;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid rgba(255, 255, 255, 0.95);\n  box-shadow: 0 1px 4px rgba(28, 30, 32, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var StyledDropdownWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  .ant-dropdown-trigger {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"])));
var StyledBody = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n"])));
/** Fixed height for two title lines so divider and meta rows align across the grid. */

var StyledTitleSlot = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  height: calc(", " * ", " * ", ");\n  overflow: hidden;\n"])), TITLE_MAX_LINES, TITLE_LINE_HEIGHT, getSize('typo14'));
var StyledFormTitle = styled.p(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 700;\n  line-height: ", ";\n  color: ", ";\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n"])), getSize('typo14'), TITLE_LINE_HEIGHT, getColor('textIntDefault'), TITLE_MAX_LINES);
var StyledMetaBlock = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 10px;\n"])));
var StyledDivider = styled(Divider)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  margin: 8px 0 8px !important;\n  border-color: ", " !important;\n"])), getColor('fillIntSubActive'));
var StyledMetaRow = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: ", ";\n  .anticon {\n    font-size: 13px;\n    color: ", ";\n  }\n"])), getColor('textIntSub'), getColor('textIntSub'));
var StyledMetaText = styled(CardSupportText)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  text-align: left;\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: ", ";\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledUpdatedAtRow = styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n\n  .anticon {\n    flex-shrink: 0;\n    font-size: 12px;\n    color: ", ";\n  }\n"])), getColor('textIntSub'));
var StyledUpdatedAtText = styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n"])));
var StyledUpdatedAtLabel = styled.span(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  line-height: 1.3;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: ", ";\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledUpdatedAtDateTime = styled.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 6px;\n  line-height: 1.35;\n"])));
var StyledUpdatedAtDate = styled.span(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n"])), getSize('typo12'), getColor('textIntDefault'));
var StyledUpdatedAtTime = styled.span(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledUpdatedAtStatus = styled.span(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n"])), getSize('typo12'), getColor('textIntDefault'));
var StyledAssignButtonWrap = styled.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  margin-top: auto;\n  padding-top: ", ";\n  flex-shrink: 0;\n"])), getSize('gap12'));
var StyledAssignButton = styled(SecondaryButton)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 40px;\n  border-radius: 10px;\n  font-weight: 600;\n"])));

var truncateLabel = function truncateLabel(text) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;
  return text.length > maxLength ? "".concat(text.slice(0, maxLength), "\u2026") : text;
};

var parseUpdatedAt = function parseUpdatedAt(unixTimestamp) {
  if (!unixTimestamp) {
    return null;
  }

  var formatted = UnixTimestamp.convertToDate(unixTimestamp);

  var _formatted$split = formatted.split(' '),
      _formatted$split2 = _slicedToArray(_formatted$split, 3),
      date = _formatted$split2[0],
      hourMinute = _formatted$split2[1],
      period = _formatted$split2[2];

  if (!date || !hourMinute) {
    return null;
  }

  return {
    date: date,
    time: period ? "".concat(hourMinute, " ").concat(period) : hourMinute
  };
};

var isSkillTag = function isSkillTag(key) {
  return SKILL_TAG_KEYS.has(key);
};

var FormCardCoverTags = function FormCardCoverTags(_ref) {
  var _form$tags;

  var form = _ref.form,
      otherLabel = _ref.otherLabel;
  var tags = (_form$tags = form.tags) !== null && _form$tags !== void 0 ? _form$tags : [];
  var visibleTags = tags.slice(0, MAX_VISIBLE_TAGS);
  var overflowCount = tags.length - visibleTags.length;
  var overflowTags = tags.slice(MAX_VISIBLE_TAGS);
  var hasCategory = Boolean(form.category);
  var hasTags = tags.length > 0;
  var hasNoTagOrCategory = !hasCategory && !hasTags;

  var renderTagPill = function renderTagPill(tag) {
    var label = truncateLabel(tag.key, 14);

    if (isSkillTag(tag.key)) {
      var _SKILL_ICONS$tag$key;

      return /*#__PURE__*/_jsx(Tooltip, {
        title: tag.key,
        children: /*#__PURE__*/_jsxs(SkillPill, {
          children: [(_SKILL_ICONS$tag$key = SKILL_ICONS[tag.key]) !== null && _SKILL_ICONS$tag$key !== void 0 ? _SKILL_ICONS$tag$key : /*#__PURE__*/_jsx(FileTextOutlined, {}), /*#__PURE__*/_jsx("span", {
            children: label
          })]
        })
      }, tag.id.toString());
    }

    return /*#__PURE__*/_jsx(Tooltip, {
      title: tag.key,
      children: /*#__PURE__*/_jsxs(TopicPill, {
        children: [/*#__PURE__*/_jsx(FileTextOutlined, {}), /*#__PURE__*/_jsx("span", {
          children: label
        })]
      })
    }, tag.id.toString());
  };

  return /*#__PURE__*/_jsxs(TagsWrap, {
    children: [hasCategory ? /*#__PURE__*/_jsx(Tooltip, {
      title: form.category.key,
      children: /*#__PURE__*/_jsx(CategoryPill, {
        children: truncateLabel(form.category.key, 12)
      })
    }) : null, visibleTags.map(renderTagPill), hasNoTagOrCategory ? /*#__PURE__*/_jsx(DefaultPill, {
      children: otherLabel
    }) : null, overflowCount > 0 ? /*#__PURE__*/_jsx(Tooltip, {
      title: overflowTags.map(function (tag) {
        return tag.key;
      }).join(', '),
      placement: "top",
      children: /*#__PURE__*/_jsxs(OverflowPill, {
        children: ["+", overflowCount]
      })
    }) : null]
  });
};

export var FormCardComponent = function FormCardComponent(_ref2) {
  var _form$totalQuestions, _updatedAtParts$date;

  var hoverable = _ref2.hoverable,
      cardLabel = _ref2.cardLabel,
      form = _ref2.form,
      onClickCard = _ref2.onClickCard,
      onAssignTest = _ref2.onAssignTest,
      onRename = _ref2.onRename,
      onDelete = _ref2.onDelete,
      onDuplicateForm = _ref2.onDuplicateForm,
      onMove = _ref2.onMove,
      loadingFormId = _ref2.loadingFormId,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var coverGradient = useMemo(function () {
    return getExploreCoverGradient(form.id.toString());
  }, [form.id]);
  var coverImageUrl = useMemo(function () {
    return getFormCoverImageUrl(form);
  }, [form.coverImage, form.thumbnail]);
  var updatedAtParts = useMemo(function () {
    return parseUpdatedAt(form.updatedAt);
  }, [form.updatedAt]);

  var _useState = useState(false),
      hasCoverImageError = _useState[0],
      setHasCoverImageError = _useState[1];

  useEffect(function () {
    setHasCoverImageError(false);
  }, [coverImageUrl, form.id]);
  var shouldShowCoverImage = Boolean(coverImageUrl) && !hasCoverImageError;
  return /*#__PURE__*/_jsx(StyledCard, _objectSpread(_objectSpread({}, rest), {}, {
    hoverable: hoverable,
    onClick: onClickCard,
    cover: /*#__PURE__*/_jsxs(StyledCoverWrapper, {
      $gradient: coverGradient,
      $hasImage: shouldShowCoverImage,
      children: [shouldShowCoverImage ? /*#__PURE__*/_jsx(StyledCoverImage, {
        draggable: false,
        alt: "",
        src: coverImageUrl,
        onError: function onError() {
          return setHasCoverImageError(true);
        }
      }) : null, /*#__PURE__*/_jsx(FormCardCoverTags, {
        form: form,
        otherLabel: t('other')
      }), /*#__PURE__*/_jsx(StyledTopRightAction, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        children: /*#__PURE__*/_jsx(StyledDropdownWrapper, {
          children: /*#__PURE__*/_jsx(FormCardDropdownComponent, {
            form: form,
            cardLabel: cardLabel,
            onRename: onRename,
            onDelete: onDelete,
            onAssignTest: onAssignTest,
            onDuplicate: onDuplicateForm,
            onMove: onMove,
            loadingFormId: loadingFormId
          })
        })
      })]
    }),
    children: /*#__PURE__*/_jsxs(StyledBody, {
      children: [/*#__PURE__*/_jsx(StyledTitleSlot, {
        children: /*#__PURE__*/_jsx(StyledFormTitle, {
          title: form.title,
          children: form.title
        })
      }), /*#__PURE__*/_jsxs(StyledMetaBlock, {
        children: [/*#__PURE__*/_jsxs(StyledMetaRow, {
          children: [/*#__PURE__*/_jsx(UnorderedListOutlined, {
            "aria-hidden": true
          }), /*#__PURE__*/_jsxs(StyledMetaText, {
            children: [cardLabel.totalQuestions, ": ", (_form$totalQuestions = form.totalQuestions) !== null && _form$totalQuestions !== void 0 ? _form$totalQuestions : 0]
          })]
        }), /*#__PURE__*/_jsx(StyledDivider, {}), /*#__PURE__*/_jsxs(StyledUpdatedAtRow, {
          children: [/*#__PURE__*/_jsx(CalendarOutlined, {
            "aria-hidden": true
          }), /*#__PURE__*/_jsxs(StyledUpdatedAtText, {
            children: [/*#__PURE__*/_jsx(StyledUpdatedAtLabel, {
              children: cardLabel.lastUpdated
            }), form.status === FormStatus.Processing ? /*#__PURE__*/_jsx(StyledUpdatedAtStatus, {
              children: cardLabel.fileImporting
            }) : /*#__PURE__*/_jsxs(StyledUpdatedAtDateTime, {
              children: [/*#__PURE__*/_jsx(StyledUpdatedAtDate, {
                children: (_updatedAtParts$date = updatedAtParts === null || updatedAtParts === void 0 ? void 0 : updatedAtParts.date) !== null && _updatedAtParts$date !== void 0 ? _updatedAtParts$date : '-'
              }), updatedAtParts !== null && updatedAtParts !== void 0 && updatedAtParts.time ? /*#__PURE__*/_jsx(StyledUpdatedAtTime, {
                children: updatedAtParts.time
              }) : null]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx(StyledAssignButtonWrap, {
        children: /*#__PURE__*/_jsx(StyledAssignButton, {
          size: "small",
          onClick: function onClick(e) {
            e.stopPropagation();
            onAssignTest(form);
          },
          icon: loadingFormId === form.id.toString() ? undefined : /*#__PURE__*/_jsx(UsergroupAddOutlined, {}),
          loading: loadingFormId === form.id.toString(),
          children: cardLabel.assignTest
        })
      })]
    })
  }));
};